import { Outlet, Route, Routes, Navigate } from 'react-router-dom';
import { Authenticated } from './authentication';
import AuthenticatedPhotosPageProvider from './photos/AuthenticatedPhotosPageProvider';
import UnauthenticatedPhotosPageProvider from './photos/UnauthenticatedPhotosPageProvider';

export const PHOTOS_PAGE_ROUTE = '/photos';
export const UNAUTHENTICATED_PHOTOS_PAGE_ROUTE = '/email-photos';
// eslint-disable-next-line max-len
export const LOGIN_ROUTE = `${process.env.REACT_APP_WOO_URL}/my-account/orders/?redirect_to=${process.env.REACT_APP_WOO_URL}my-account/v2/#/photos/`;

const ProtectedPage = () => {
  return <Authenticated element={<Outlet />} />;
};

const UnprotectedPage = () => {
  return <Outlet />;
};

function Router() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={PHOTOS_PAGE_ROUTE} />}></Route>
      <Route path={PHOTOS_PAGE_ROUTE} element={<ProtectedPage />}>
        <Route index element={<AuthenticatedPhotosPageProvider />} />
      </Route>
      <Route path={UNAUTHENTICATED_PHOTOS_PAGE_ROUTE} element={<UnprotectedPage />}>
        <Route index element={<UnauthenticatedPhotosPageProvider />} />
      </Route>
    </Routes>
  );
}

export default Router;
